import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=021ee90d"
import script from "./TextEditor.vue?vue&type=script&lang=js"
export * from "./TextEditor.vue?vue&type=script&lang=js"
import style0 from "./TextEditor.vue?vue&type=style&index=0&id=021ee90d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports